import { isDefined } from "@clipboard-health/util-ts";
import { useTu } from "@src/appV2/i18n/useTu";
import { Text } from "../../components/Text";
import { formatAgentRequestLabel } from "../../DailyView/utils/formatAgentRequestLabel";

interface QualificationCaptionProps {
  /** When set, the migration is scoped to this qualification; otherwise "Any". */
  qualification?: string;
}

/** Secondary caption echoing the qualification filter applied to a migration. */
export function QualificationCaption(props: QualificationCaptionProps) {
  const { qualification } = props;
  const { tu } = useTu("shiftMigration");

  return (
    <Text sx={(theme) => ({ color: theme.palette.text.secondary })} variant="caption">
      {isDefined(qualification)
        ? tu("Qualification: {{qualification}}", {
            values: { qualification: formatAgentRequestLabel(qualification) },
          })
        : tu("Qualification: Any")}
    </Text>
  );
}
